import styled from 'styled-components';
export var ErrorMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ErrorMessage",
  componentId: "sc-1x9qpvy-0"
})(["color:", ";margin-top:3px;min-height:35px;visibility:", ";opacity:", ";transition:100ms linear all;"], p => p.theme.colors.error, p => p.showError ? 'visible' : 'hidden', p => p.showError ? '1' : '0');